module.exports = __webpack_public_path__ + "static/media/logo.75c03f30.png";